<dx-toolbar id="fieldToolbar" class="field-editor-map-toolbar">

  <dxi-item location="before" locateInMenu="never">
    <div *dxTemplate>
      <div class="flex flex-row items-center">
        <span class="block color mx-2" [ngStyle]="{backgroundColor: field?.color}"></span>
        <span class="block mr-2 text-sm font-light px-2">{{field?.name}} </span>
      </div>
    </div>
  </dxi-item>

  <dxi-item location="before" locateInMenu="never">
    <div *dxTemplate>
      <div class="flex flex-row items-center bg-gray-200 px-2 py-1 mx-2 rounded">
        <ic-icon [icon]="areaIcon" height="18px" width="18px"></ic-icon>
        <span class="font-bold px-1">{{field?.polygonAreaToHaUnit()}}</span>
      </div>
    </div>
  </dxi-item>

  <dxi-item
    *ngIf="fieldCropsBtnVisible"
    location="after"
    locateInMenu="never"
    widget="dxButton"
    [options]="cropButtonOptions">
  </dxi-item>

  <dxi-item widget="dxButton"
            location="after"
            locateInMenu="never"
            [options]="editButtonOptions">
  </dxi-item>

  <dxi-item widget="dxButton"
            location="after"
            locateInMenu="never"
            [options]="drawButtonOptions">
  </dxi-item>


  <dxi-item widget="dxButton"
            location="after"
            [options]="deleteButtonOptions">
  </dxi-item>

  <dxi-item *ngIf="hasChanges()" location="after" locateInMenu="never">
    <div *dxTemplate>
      <div class="relative">
        <dx-button
          icon="save"
          text="Sauvegarder"
          (onClick)="saveChanges()"
          stylingMode="text">
        </dx-button>
        <span [ngClass]="{'has-errors': hasDrawingErrors()}" class="button-badge"></span>
      </div>
    </div>
  </dxi-item>

  <dxi-item *ngIf="loadingVisible" location="after" locateInMenu="never">
    <div *dxTemplate>
      <dx-load-indicator style="margin:4px" height="20" width="20"></dx-load-indicator>
    </div>
  </dxi-item>

  <dxi-item location="after" locateInMenu="never">
    <div *dxTemplate><span style="height: 30px" class="block border-l border-solid border-gray-400"></span></div>
  </dxi-item>

  <dxi-item widget="dxButton"
            location="after"
            locateInMenu="never"
            [options]="closeButtonOptions">
  </dxi-item>
</dx-toolbar>

<dx-popover class="field-editor-changes-popover"
            [width]="600"
            target="#fieldToolbar"
            [deferRendering]="false"
            [showTitle]="true"
            [(visible)]="formVisible"
            (onHiding)="formOnHiding()"
            [elementAttr]="{class: 'field-editor-changes-popover'}"
            position="bottom"
            title="Modification"
            [container]="container.getElement()"
            [showCloseButton]="true"
            [closeOnOutsideClick]="true">
  <div *dxTemplate="let model of 'content'">
    <dx-form id="form"
             [formData]="field"
             [showValidationSummary]="true"
             (onFieldDataChanged)="addFormChange($event)">
      <dxi-item itemType="group" colSpan="2" colCount="2">
        <dxi-item dataField="code">
          <dxo-label text="Code"></dxo-label>
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxi-validation-rule type="async" message="Code existe déjà"
                               [validationCallback]="codeValidation"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="name">
          <dxo-label text="Nom"></dxo-label>
          <dxi-validation-rule type="required" message="Le nom est obligatoire"></dxi-validation-rule>
          <dxi-validation-rule type="stringLength" [min]="3" [max]="100"></dxi-validation-rule>
        </dxi-item>
      </dxi-item>
      <dxi-item itemType="group" colSpan="2" colCount="2">
        <dxi-item dataField="domain_id">
          <dxo-label text="Domaine"></dxo-label>
          <div *dxTemplate>
            <app-user-domains-chooser (valueChange)="domainChange($event)"
                                      [id]="field?.domain_id"></app-user-domains-chooser>
          </div>
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="cadastral_area" editorType="dxNumberBox" [editorOptions]="{format: '#0.## Ha'}">
          <dxo-label text="Superficie Cadastrale"></dxo-label>
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
      </dxi-item>
      <dxi-item itemType="group" colSpan="2" colCount="2">
        <dxi-item dataField="color" editorType="dxColorBox">
          <dxo-label text="Couleur"></dxo-label>
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="is_irrigated" editorType="dxSwitch">
          <dxo-label text="Irriguée?"></dxo-label>
        </dxi-item>
      </dxi-item>
      <dxi-item *ngIf="thirdpartySystemFields.length > 0 && canEditThirdPartSystems" itemType="group" colCount="2" [items]="thirdpartySystemFields"
                caption="Systèmes extérieurs"></dxi-item>
      <dxi-item itemType="group" colSpan="2" colCount="1">
        <dxi-item
          dataField="description"
          editorType="dxTextArea"
          [editorOptions]="{ height: 70 }"></dxi-item>
      </dxi-item>
      <dxi-item
        itemType="button"
        horizontalAlignment="right"
        [buttonOptions]="formSaveBtnOptions">
      </dxi-item>
    </dx-form>
  </div>
</dx-popover>

<dx-popup class="field-editor-field-crops-popover"
          [width]="380"
          [height]="500"
          [animation]="{ show: { type: 'fade', from: 0, to: 1 }, hide: { type: 'fade', to: 0 } }"
          [showTitle]="true"
          [container]="container.getElement()"
          [(visible)]="fieldCropListVisible"
          [elementAttr]="{class: 'field-editor-field-crops-popover'}"
          title="Liste des cultures"
          [dragEnabled]="true"
          [resizeEnabled]="true"
          [shading]="false"
          [showCloseButton]="true"
          [closeOnOutsideClick]="false">
  <div *dxTemplate="let model of 'content'">
    <app-field-editor-map-crop-list *ngIf="field" [field]="field"></app-field-editor-map-crop-list>
  </div>
</dx-popup>

<dx-load-panel
  [deferRendering]="false"
  shadingColor="rgba(0,0,0,0.2)"
  [container]="'#fieldToolbar'"
  [visible]="loadingVisible || lockToolbar"
  [showIndicator]="false"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>

<dx-speed-dial-action
  icon="add"
  [visible]="!editingEnabled"
  [index]="1"
  (onClick)="drawField()">
</dx-speed-dial-action>

<app-field-crops-popup></app-field-crops-popup>
